export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Luxurious%20dark%20walnut%20wood%20desk%20surface%20with%20carefully%20arranged%20fashion%20essentials%20including%20premium%20watch%2C%20folded%20cashmere%20sweater%2C%20sunglasses%20and%20leather%20wallet%2C%20dramatic%20single%20directional%20warm%20light%20from%20left%20side%20creating%20rich%20shadows%2C%20deep%20espresso%20brown%20tones%2C%20editorial%20still%20life%20photography%20with%20elegant%20lifestyle%20atmosphere&width=1600&height=900&seq=hero-bg-v3&orientation=landscape"
        alt="Pandabuy Spreadsheet product sourcing lifestyle"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 h-full flex flex-col justify-center px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl">
          <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-extrabold leading-[1.05] tracking-tight mb-4">
            Pandabuy Spreadsheet
          </h1>
          <p className="text-white/90 text-lg md:text-xl lg:text-2xl font-light leading-relaxed max-w-xl mb-10">
            The most advanced product sourcing &amp; shopping comparison system with curated spreadsheets updated daily.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center justify-between gap-3 px-7 py-4 rounded-full bg-white text-foreground-950 font-semibold text-base hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer w-fit"
          >
            <span>Pandabuy Sheet</span>
            <span className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-sm"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center justify-between gap-3 px-7 py-4 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer w-fit"
          >
            <span>Buy It Now</span>
            <span className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-white text-sm"></i>
            </span>
          </a>
        </div>

        <div className="mt-12 flex flex-wrap gap-6">
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            <span>Updated Daily</span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            <span>10,000+ Products</span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            <span>Smart Scoring</span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            <span>Global Shipping</span>
          </div>
        </div>
      </div>
    </section>
  );
}